<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	data?: { month: string; inbound: number; outbound: number }[]
}>()

const chartOptions = computed(() => ({
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'cross',
			label: {
				backgroundColor: '#6a7985'
			}
		}
	},
	legend: {
		data: ['Inbound', 'Outbound']
	},
	grid: {
		left: '3%',
		right: '4%',
		bottom: '3%',
		containLabel: true
	},
	xAxis: [
		{
			type: 'category',
			boundaryGap: false,
			data: props.data?.map(item => item.month) || []
		}
	],
	yAxis: [
		{
			type: 'value',
			name: 'Bandwidth (GB)'
		}
	],
	series: [
		{
			name: 'Inbound',
			type: 'line',
			stack: 'Total',
			areaStyle: {},
			emphasis: {
				focus: 'series'
			},
			data: props.data?.map(item => item.inbound) || [],
			color: '#3b82f6'
		},
		{
			name: 'Outbound',
			type: 'line',
			stack: 'Total',
			areaStyle: {},
			emphasis: {
				focus: 'series'
			},
			data: props.data?.map(item => item.outbound) || [],
			color: '#ef4444'
		}
	]
}))
</script>

<template>
	<BaseChart :options="chartOptions" class="h-full w-full" />
</template>
